import { useEffect, useRef, useState } from "react";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
// COMPONENTE
import ZonaCargando from "../alertas/zonaCargando";
import ListaChats from "../../componentesEspeciales/soporteAdmin/listaChats";

function SoporteAdmin() {
  const { usuario, cargandoUsuario, setUsuario, entornoApp, ahoraServidor } =
    useOutletContext() || {}; // variables que vienen de direccionameinto
  const [cargando, setCargando] = useState(false);
  const [chats, setChats] = useState([]);
  const [estadoChats, setEstadoChats] = useState("activos");
  const [pagina, setPagina] = useState(1);
  const [paginacion, setPaginacion] = useState({
    total: 0,
    pagina: 1,
    limite: 20,
    totalPaginas: 1,
    hayMas: false,
  });
  const cargandoFinal = Boolean(cargandoUsuario) || Boolean(cargando);
  const pollingRef = useRef(null);

  async function fetchChats({ inicial = false } = {}) {
    if (!usuario) return;

    try {
      if (inicial) setCargando(true);

      const estadoBackend = estadoChats === "finalizados" ? "resuelta" : "activos";

      const res = await axios.post("/obtener-chats", {
        params: { pagina, limite: 20, estado: estadoBackend },
      });

      setChats(res?.data?.chats || []);
      setPaginacion(
        res?.data?.paginacion || {
          total: 0,
          pagina,
          limite: 20,
          totalPaginas: 1,
          hayMas: false,
        },
      );
    }
    catch (err) {
      if (inicial) {
        console.log("Error obteniendo chats de WhatsApp:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No pudimos obtener los chats de soporte.",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    }
    finally {
      if (inicial) setCargando(false);
    }
  }

  useEffect(() => {
    fetchChats({ inicial: true });

    // Polling cada 10 s solo en chats activos (los finalizados no cambian)
    if (estadoChats === "activos") {
      pollingRef.current = setInterval(() => {
        fetchChats({ inicial: false });
      }, 10000);
    }

    return () => clearInterval(pollingRef.current);
  }, [usuario, estadoChats, pagina]);

  function cambiarEstadoChats(nuevoEstado) {
    setEstadoChats(nuevoEstado);
    setPagina(1);
  }

  async function reactivarChat(chat) {
    if (!chat?.idConversacion) return;

    try {
      const res = await axios.post("/reactivar-conversacion", {
        params: {
          idConversacion: chat.idConversacion,
          asesor: { username: usuario?.username || "soporte" },
        },
      });

      if (res?.data?.exito) {
        Swal.fire({
          icon: "success",
          title: "Chat reactivado",
          text: "La conversación está activa nuevamente.",
          timer: 1800,
          showConfirmButton: false,
        });
        fetchChats({ inicial: false });
      } else {
        Swal.fire({ icon: "error", title: "Error", text: res?.data?.mensaje || "No pudimos reactivar el chat.", timer: 2000, showConfirmButton: false });
      }
    } catch (err) {
      console.log("Error reactivando chat:", err);
      Swal.fire({ icon: "error", title: "Error", text: "No pudimos reactivar el chat.", timer: 2000, showConfirmButton: false });
    }
  }

  return (
    <div>
      {cargandoFinal ? (
        <ZonaCargando />
      ) : usuario ? (
        <div className="container-fluid">
          {/* Contenedor título */}
          <div className="pt-3 pb-2 mb-3 border-bottom">
            <h1 className="h2 text-dark mb-1">Soporte</h1>
            <p className="text-muted mb-0 small">
              Gestiona los chats de WhatsApp que necesitan atención de un
              asesor.
            </p>
          </div>

          <ListaChats
            chats={chats}
            estadoChats={estadoChats}
            cambiarEstadoChats={cambiarEstadoChats}
            paginacion={paginacion}
            setPagina={setPagina}
            onReactivar={reactivarChat}
          />
        </div>
      ) : null}
    </div>
  );
}

export default SoporteAdmin;
